import {
  Activities,
  Activity,
  ParsedActivity,
  ParsedActivities,
} from './types';

const parse = (item: Activity): Readonly<ParsedActivity> =>
  Object.freeze({
    id: item.id || '',
    code: item.code || '',
    note: item.announce || '',
    text: item.description || '',
    img: item.image_src || '',
    link: {
      name: 'activity',
      params: { code: item.code || '', id: String(item.id) },
    },
    title: item.name || '',
    is_locked: item.is_locked || false,
  });

const parseActivities = (data: Activities): ParsedActivities => data.map(parse);

export default parseActivities;



// WEBPACK FOOTER //
// ./src/services/api/activities/utils/parseActivities.ts